(() => {
  const activateSelectedVideo = () => {
    document
      .querySelectorAll('.product__media-item.is-active .media-type-video deferred-media:not([loaded])')
      .forEach((media) => media.querySelector('.deferred-media__poster')?.click());

    document.querySelectorAll('.product__media-item.is-active .media-type-video video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.controls = false;
      video.play().catch(() => {});
    });
  };

  const galleries = document.querySelectorAll('media-gallery');

  galleries.forEach((gallery) => {
    new MutationObserver(activateSelectedVideo).observe(gallery, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  });

  activateSelectedVideo();
})();
